import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function sendMailCode(email, code, key) {
  return request({
    url: '/auth/send-mail-code',
    method: 'post',
    data: {
      email,
      code,
      key
    }
  })
}

export function captcha() {
  return request({
    url: '/auth/captcha',
    method: 'get',
    data: {}
  })
}

export function changePassword(data) {
  return request({
    url: '/change-password',
    method: 'post',
    data: data
  })
}

export function initPassword(id) {
  return request({
    url: '/init-password/' + id,
    method: 'post'
  })
}

export function findPassword(data) {
  return request({
    url: '/auth/find-password',
    method: 'post',
    data,
  })
}

export function update(id, data) {
  return request({
    url: '/user/' + id,
    method: 'patch',
    data
  })
}
